package com.appsyde.contract.recommended

/**
 * Calcul déterministe de l'action recommandée (code + label + why).
 * Partagé front (réactivité) et back (persistence) pour le même résultat.
 */
object RecommendedActionComputer {

    private val RESOLUTION_INTENTS = setOf(
        "damaged_product", "wrong_item", "missing_item", "refund_request", "cancellation"
    )

    fun compute(state: RecommendedActionState): RecommendedActionUi {
        val code = computeCode(state)
        return RecommendedActionLabelsFr.buildUi(code, state)
    }

    private fun computeCode(state: RecommendedActionState): RecommendedActionCode {
        val intent = state.intent?.trim()?.lowercase()
        val missingP0 = state.missing
            .filter { CognitiveWeight.weight(intent, it, state) == Weight.P0 }
            .toSet()
        val confirmP0 = state.toConfirm
            .filter { CognitiveWeight.weight(intent, it, state) == Weight.P0 }
            .toSet()

        when {
            "order_number" in missingP0 -> return RecommendedActionCode.ASK_ORDER_NUMBER
            "account_id" in missingP0 -> return RecommendedActionCode.ASK_ACCOUNT_ID
            "tracking_number" in missingP0 -> return RecommendedActionCode.ASK_TRACKING_NUMBER
            "photo_proof" in missingP0 -> return RecommendedActionCode.ASK_PHOTO_PROOF
            "refund_preference" in missingP0 -> return RecommendedActionCode.CONFIRM_REFUND_PREFERENCE
        }

        when {
            "login_identifier" in confirmP0 -> return RecommendedActionCode.REQUEST_LOGIN_IDENTIFIER
            "refund_preference" in confirmP0 -> return RecommendedActionCode.CONFIRM_REFUND_PREFERENCE
        }

        return when (intent) {
            "password_reset" -> {
                if ("login_identifier" in missingP0 || "login_identifier" in confirmP0) {
                    RecommendedActionCode.REQUEST_LOGIN_IDENTIFIER
                } else {
                    RecommendedActionCode.SEND_PASSWORD_RESET
                }
            }
            "bug_report" -> {
                if ("account_id" in missingP0) {
                    RecommendedActionCode.ASK_ACCOUNT_ID
                } else {
                    RecommendedActionCode.TRIAGE_BUG
                }
            }
            else -> {
                if (intent != null && intent in RESOLUTION_INTENTS) {
                    RecommendedActionCode.PREPARE_RESOLUTION
                } else {
                    RecommendedActionCode.PREPARE_REPLY
                }
            }
        }
    }
}
